import * as React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router';
import PrimaryButton from '../../common/buttons/PrimaryButton';
import { getCustomerIdFromAccessToken } from '../../../core/session';
import { smartRecruiters } from '../../../core/constants';
import { getIntegrationsByCustomerId, smartRecruitersConsent } from '../../../core/integrations';

const SmartRecruitersConsent = () => {
	const { id } = useParams<{ id: string }>();
	const customerId = getCustomerIdFromAccessToken();
	const generateClientCredentials = async () => {
		const customerIntegrations = await getIntegrationsByCustomerId(customerId);
		const integration = customerIntegrations.find((x) => x.name?.toLowerCase() === smartRecruiters);
		await smartRecruitersConsent(customerId, integration.integrationId, id);
	};

	return (
		<ConsentContainer>
			SmartRecruiters is requesting access to the following from your VETTING.com account:
			<ul>
				<li>Read access to available checks</li>
				<li>Read access to screening packages</li>
				<li>Request new checks</li>
			</ul>
			<Button>
				<PrimaryButton text="Approve" onClick={generateClientCredentials} />
			</Button>
		</ConsentContainer>
	);
};

const ConsentContainer = styled.div`
	display: block;
	margin: 40px;
`;

const Button = styled.div`
	display: block;
	margin: 0 0 0 50px;
`;

export default SmartRecruitersConsent;
